
<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import Loader from "@/components/widgets/preloader";
import { mapGetters,mapActions,mapState } from "vuex"
import Swal from "sweetalert2";
import moment from "moment";
import axios from "axios";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Store Purchases Report",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    Loader,
  },
  data() {
    return {
      filterPurchases: {
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        product: '',
        title: 'Store Purchase Report'
      },
      title: "Store Purchase Report",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Store Purchases Report",
          active: true,
        },
      ],
      totalRows: 1,
      total_amount:0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "product",
          sortable: true,
          label: "PRODUCT",
        },
        {
          key: "qty",
          sortable: true,
          label: "QUANTITY",
        },
        {
          key: "unitPrice",
          sortable: true,
          label: "UNIT PRICE",
        },
        {
          key: "total",
          sortable: true,
          label: "TOTAL",
        },
        {
          key: "purchase.date",
          sortable: true,
          label: "DATE",
        }
      ],
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("purchase", ["SaveStatus","StorePurchasesReport"]),
    ...mapGetters("setting", ["PaymentOptions"]),
    ...mapGetters("products", ["Products"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.StorePurchasesReport ? this.StorePurchasesReport.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.StorePurchasesReport ? this.StorePurchasesReport.length : 1;
  },
  methods: {
    ...mapActions({
      FetchPurchasesReport: "purchase/fetchStorePurchasesReport",
      FetchModes: "setting/fetchPaymentOptions",
      FetchProducts: "products/fetchProducts",


    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/[^0-9.]+/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    addCommas() {
      this.edit.paid = this.thousandSeperator(this.edit.paid);
    },
    PurchasesReportData(){
      this.FetchPurchasesReport(this.filterPurchases);
    },
     Excel_export() {
      axios
        .post("export_storepurchases", this.filterPurchases,{
          responseType: "arraybuffer",
        })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", "sales_report.xlsx");
          document.body.appendChild(fileLink);
          fileLink.click();
          // this.$toast.add({
          //   severity: "success",
          //   summary: "Successful",
          //   detail: "Sales Report Downloaded successfully",
          //   life: 6000,
          // });
          this.spinner = false;
        })
        .catch(() => {
          // this.spinner = false;
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Something wrong",
          //   detail: "Sales Report Download failed",
          //   life: 6000,
          // });
        });
    },
  },
  updated() {
    let total_amount = 0;
      // let total_paid = 0;
      if(this.StorePurchasesReport){
        this.StorePurchasesReport.forEach((item)=>{
          total_amount = total_amount+parseInt(item.total);
        });
        this.total_amount = total_amount;
        // this.PurchasesReport.forEach((item)=>{
        //   total_paid = total_paid+item.sale.paid;
        // });
        // this.total_paid = total_paid;
      }
  },
  watch: {
    StorePurchasesReport(newValue){
      if(newValue == true){
        this.PurchasesReportData();
      }
    },
    show(newValue) {
      if (newValue == true) {
        if (this.type == "success") {
            this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  created() {
    this.FetchPurchasesReport(this.filterPurchases);
    this.FetchModes();
    this.FetchProducts();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h3 class="card-title mb-2 text-center" v-html="filterPurchases.title"></h3>
              </div>

            </div>
            <div class="row">
              <div class="col-md-3 mt-4">
                <b-button variant="info" @click="Excel_export()"
                  ><i class="fa fa-download"></i>Export</b-button
                >
              </div>
              <div class="col-md-3 form-group mb-2">
                <label>FROM</label>
                <input
                  @change="PurchasesReportData()"
                  type="date"
                  v-model="filterPurchases.datefrom"
                  class="form-control"
                />
              </div>
              <div class="col-md-3 form-group">
                <label>TO</label>
                <input
                  @change="PurchasesReportData()"
                  v-model="filterPurchases.dateto"
                  type="date"
                  class="form-control"
                />
              </div>
              <div class="col-md-3 form-group">
                <label>PRODUCT</label>
                
                <model-list-select
                  :list="Products ? Products : []"
                  v-model="filterPurchases.product"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Product"
                  @input="PurchasesReportData()"
                >
                </model-list-select>
              </div>
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="StorePurchasesReport?StorePurchasesReport:[]"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(unitPrice)="data">
                  {{ thousandSeperator(data.item.unitPrice) }}
                </template>
                <template #cell(total)="data">
                  {{ thousandSeperator(data.item.total) }}
                </template>
              </b-table>
              <div class="row">
                  <div class="col-md-2"></div>
                  <div class="col-md-4">
                    <h5>Total Amount: <span class="text-danger">{{thousandSeperator(total_amount)}}</span></h5>
                  </div>
                </div>
            </div>
            <Loader  v-if="!StorePurchasesReport"/>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
